import { Component, effect, inject } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';

import { UserStore } from '@core/stores/user.store';

import { AppMenuitem } from './app.menuitem';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [AppMenuitem, RouterModule],
  template: `<ul class="layout-menu">
    @for (item of model; track $index) {
      @if (!item.separator) {
        <li app-menuitem [item]="item" [index]="$index" [root]="true"></li>
      }
      @if (item.separator) {
        <li class="menu-separator"></li>
      }
    }
  </ul> `,
})
export class AppMenu {
  private readonly userStore = inject(UserStore);

  model: MenuItem[] = [];

  constructor() {
    effect(() => {
      this.model = this.buildMenu(this.userStore.user()?.userType === 'admin');
    });
  }

  private buildMenu(isAdmin: boolean): MenuItem[] {
    return [
      {
        // label: 'Inversiones.io',
        items: [
          { label: 'Gana IO COINS', icon: 'pi pi-fw pi-money-bill', routerLink: ['/io-coins'] },
          { label: 'Perfil', icon: 'pi pi-fw pi-user', routerLink: ['/perfil'] },
          ...(isAdmin
            ? [
                {
                  label: 'Admin',
                  icon: 'pi pi-fw pi-shield',
                  items: [
                    {
                      label: 'Perfiles KYC',
                      icon: 'pi pi-fw pi-verified',
                      routerLink: ['/admin/profiles'],
                    },
                    {
                      label: 'Proveedores',
                      icon: 'pi pi-fw pi-id-card',
                      routerLink: ['/admin/user-service-provider'],
                    },
                    {
                      label: 'Canjes IO COINS',
                      icon: 'pi pi-fw pi-file-excel',
                      routerLink: ['/admin/millas-canjear'],
                    },
                    {
                      label: 'Cuentas Bancarias',
                      icon: 'pi pi-fw pi-credit-card',
                      routerLink: ['/admin/bank-accounts'],
                    },
                    {
                      label: 'Bancos',
                      icon: 'pi pi-fw pi-building-columns',
                      routerLink: ['/admin/banks'],
                    },
                  ],
                },
              ]
            : []),
          /* {
            label: 'Perfil',
            icon: 'pi pi-fw pi-user',
            items: [
              {
                label: 'Datos Personales',
                icon: 'pi pi-id-card',
                routerLink: ['/perfil/datos-personales'],
              },
              {
                label: 'Datos Laborales',
                icon: 'pi pi-fw pi-briefcase',
                routerLink: ['/perfil/datos-laborales'],
              },
              {
                label: 'Documentos',
                icon: 'pi pi-fw pi-file',
                routerLink: ['/perfil/documentos'],
              },
              {
                label: 'Cuentas Bancarias',
                icon: 'pi pi-fw pi-credit-card',
                routerLink: ['/perfil/cuentas-bancarias'],
              },
            ],
          }, */
          { label: 'Mis referidos', icon: 'pi pi-fw pi-users', routerLink: ['/mis-referidos'] },
          { label: 'Contacto & Legal', icon: 'pi pi-fw pi-book', routerLink: ['/contacto-legal'] },
        ],
      },
      /* {
        label: 'Página Principal',
        items: [{ label: 'Panel', icon: 'pi pi-fw pi-home', routerLink: ['/'] }],
      },
      {
        label: 'Páginas',
        items: [
          {
            label: 'Login',
            icon: 'pi pi-fw pi-sign-in',
            routerLink: ['/login'],
          },
        ],
      },
      {
        label: 'UI Components',
        items: [
          { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
          { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
          {
            label: 'Button',
            icon: 'pi pi-fw pi-mobile',
            class: 'rotated-icon',
            routerLink: ['/uikit/button'],
          },
          { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
          { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
          { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
          { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
          { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
          { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
          { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
          { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
          { label: 'File', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] },
          { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] },
          { label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/uikit/timeline'] },
          { label: 'Misc', icon: 'pi pi-fw pi-circle', routerLink: ['/uikit/misc'] },
        ],
      },
      {
        label: 'Pages',
        icon: 'pi pi-fw pi-briefcase',
        routerLink: ['/pages'],
        items: [
          {
            label: 'Landing',
            icon: 'pi pi-fw pi-globe',
            routerLink: ['/landing'],
          },
          {
            label: 'Auth',
            icon: 'pi pi-fw pi-user',
            items: [
              {
                label: 'Login',
                icon: 'pi pi-fw pi-sign-in',
                routerLink: ['/auth/login'],
              },
              {
                label: 'Error',
                icon: 'pi pi-fw pi-times-circle',
                routerLink: ['/auth/error'],
              },
              {
                label: 'Access Denied',
                icon: 'pi pi-fw pi-lock',
                routerLink: ['/auth/access'],
              },
            ],
          },
          {
            label: 'Crud',
            icon: 'pi pi-fw pi-pencil',
            routerLink: ['/pages/crud'],
          },
          {
            label: 'Not Found',
            icon: 'pi pi-fw pi-exclamation-circle',
            routerLink: ['/pages/notfound'],
          },
          {
            label: 'Empty',
            icon: 'pi pi-fw pi-circle-off',
            routerLink: ['/pages/empty'],
          },
        ],
      },
      {
        label: 'Hierarchy',
        items: [
          {
            label: 'Submenu 1',
            icon: 'pi pi-fw pi-bookmark',
            items: [
              {
                label: 'Submenu 1.1',
                icon: 'pi pi-fw pi-bookmark',
                items: [
                  { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
                  { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
                  { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' },
                ],
              },
              {
                label: 'Submenu 1.2',
                icon: 'pi pi-fw pi-bookmark',
                items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }],
              },
            ],
          },
          {
            label: 'Submenu 2',
            icon: 'pi pi-fw pi-bookmark',
            items: [
              {
                label: 'Submenu 2.1',
                icon: 'pi pi-fw pi-bookmark',
                items: [
                  { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
                  { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' },
                ],
              },
              {
                label: 'Submenu 2.2',
                icon: 'pi pi-fw pi-bookmark',
                items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }],
              },
            ],
          },
        ],
      },
      {
        label: 'Get Started',
        items: [
          {
            label: 'Documentation',
            icon: 'pi pi-fw pi-book',
            routerLink: ['/documentation'],
          },
          {
            label: 'View Source',
            icon: 'pi pi-fw pi-github',
            url: 'https://github.com/primefaces/sakai-ng',
            target: '_blank',
          },
        ],
      } */
    ];
  }
}
